import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';

import { config } from 'app/constants';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss'],
})
export class DoughnutChartComponent implements OnInit, OnChanges {
  @Input() data: any = {
    data: [0, 100],
    labels: ['', ''],
    colors: ['var(--primary-500)', 'var(--secondary-50)'],
  };
  @Input() width: any = '230px';
  @Input() left: any = '-30px';
  @Input() doughnutValueTop: any = '-75px';
  @Input() doughnutHeadingTop: any = '-55px';
  @Input() doughnutHeadingWidth: any = '145px';
  @Input() avgValueFont: any = '16px';
  @Input() trimLargeNumber: boolean = false;
  @Input() isLabelShown: boolean = false;

  @Input() brackHeading: boolean = false;
  @Input() isDescription: boolean = false;

  @Input() heading: any = '';
  @Input() tooltip: string = '';
  @Input() subHeading: any = '';
  @Input() description: any = '';
  @Input() value: any = '00';
  @Input() valueTech: any = '00';
  @Input() avgValue: any = 'Avg. 00';
  @Input() valueUnit: any = '%';
  @Input() isShowNumber: boolean = false;

  usd: any = currency.USD;

  public doughnutChartOptions: any = {
    circumference: 4,
    rotation: 2.75,
    cutoutPercentage: 70,
    plugins: {
      labels: {
        render: function (args) {
          return '';
        },
        fontColor: '#fff',
      },
    },
    tooltips: {
      // Disable the on-canvas tooltip
      enabled: false,

      custom: function (tooltipModel) {
        // Tooltip Element
        let tooltipEl: any = document.getElementById('chartjs-tooltip');

        // Create element on first render
        if (!tooltipEl) {
          tooltipEl = document.createElement('div');
          tooltipEl.id = 'chartjs-tooltip';
          tooltipEl.innerHTML = '<div class="dashboard-doughnut-chart-tooltip">sadasd</div>';
          document.body.appendChild(tooltipEl);
        } else {
          tooltipEl.id = 'chartjs-tooltip';
          tooltipEl.innerHTML = '<div class="dashboard-doughnut-chart-tooltip">sadasd</div>';
          document.body.appendChild(tooltipEl);
        }

        // Hide if no tooltip
        if (tooltipModel.opacity === 0) {
          tooltipEl.style.opacity = 0;
          return;
        }

        function getBody(bodyItem) {
          return bodyItem.lines;
        }

        // Set Text
        if (tooltipModel.body) {
          const titleLines = tooltipModel.title || [];
          const bodyLines = tooltipModel.body.map(getBody);

          let innerHtml = '<div>';
          titleLines.forEach((title) => (innerHtml += title));
          innerHtml += '</div><div class="font-bold">';

          bodyLines.forEach((body, i) => {
            const n = body[0].split(':');
            const n1 = Number(n[1]);
            if (n && n[0]) innerHtml += `${Math.round(n1)}% (${n[0]})`;
            else innerHtml += `${Math.round(n1)}%`;
          });
          innerHtml += '</div>';

          const tableRoot = tooltipEl.querySelector('.dashboard-doughnut-chart-tooltip');
          tableRoot.innerHTML = innerHtml;
        }

        // `this` will be the overall tooltip
        const position = this._chart.canvas.getBoundingClientRect();

        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1;
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.left = position.left - 62 + window.pageXOffset + tooltipModel.caretX + 'px';
        tooltipEl.style.top = position.top - 80 + window.pageYOffset + tooltipModel.caretY + 'px';
        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
        tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        tooltipEl.style.pointerEvents = 'none';
      },
    },
  };
  colorArr: { backgroundColor: string[]; borderWidth: number }[];

  constructor(private cdr: ChangeDetectorRef) { }
  ngOnChanges(change: any) {
    if (this.data) {
      if (this.data.heading === 'Tire margin') {
        this.cdr.detectChanges();
      }
      this.setColors();
    }
  }
  ngOnInit() {
    this.setColors();
  }

  setColors() {
    this.colorArr = this.data.colors.map((e) => {
      return {
        backgroundColor: this.data.colors,
        borderWidth: 0,
      };
    });
  }

  isBrackHeading() {
    return this.heading.split(' ');
  }

  isLargeNumber(): boolean {
    const numberValue = Number(this.value);
    if (isNaN(numberValue)) return false;

    const absoluteValue = Math.abs(numberValue);
    return absoluteValue >= 100 && absoluteValue <= 99999;
  }

  // isLargeNumberTech(): boolean {
  //   const numberValue = Number(this.valueTech);
  //   if (isNaN(numberValue)) return false;

  //   const absoluteValue = Math.abs(numberValue);
  //   return absoluteValue >= 100 && absoluteValue <= 99999;
  // }


}
